import PassportInformation from './PassportInformation';

export default PassportInformation;
